<template>
    <div class="agreement-page">
        <!-- <mt-header fixed title="注销账号" style="background:#ffffff;color:#262626;padding: 0 20px">
            <router-link to="/" slot="left">
                <mt-button icon="back"></mt-button>
            </router-link>
        </mt-header> -->

        <div class="main-section">
            <h1 style="margin: 0">1.&nbsp;导言</h1>

            <p>1.1&nbsp;&nbsp;欢迎您使用果师兄app软件及相关服务！</p>
            <p>果师兄app软件及相关服务（下称“本软件及相关服务”），系指苏州市朝旭科技有限公司及其关联方
                （以下简称“我方”）合法拥有并运营的、标注名称为 果师兄的客户端应用程序（包含不同版本）以及
                相关网站（https://www.guoshixiong.com/）向您提供的各项产品与服务，包括但不限于iOS移
                动设备的数据检测与咨询等核心功能及其他功能。《用户协议》（以下称“本协议”）是您与我方就您下
                载、安装、注册、登录、使用（以下统称“使用”）本软件及相关服务所订立的协议。</p>

            <p>1.2&nbsp;&nbsp;为了更好地为您提供服务，请您在开始使用本软件及相关服务之前，认真阅读并充分理解本协议，特
                别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、法律适用和争议解决条款等。其中，
                免除或者限制责任条款等重要内容将以加粗、下划线等形式提示您注意，您应重点阅读。</p>

            <p>1.3&nbsp;&nbsp;如您未成年，您以及您的法定监护人都应该仔细阅读、充分理解并同意本协议，您应该确保在全部接受
                本协议内容并征得法定监护人的同意后使用本软件及相关服务。</p>

            <p>1.4&nbsp;&nbsp;如果您不同意本协议中的任何条款，请您不要使用本软件及相关服务，您也可以随时选择停止使用本软
                件及相关服务。如您自主选择同意或使用本软件及相关服务，则视为您已充分理解本协议，并同意作为本
                协议的一方当事人接受本协议以及其他与本软件及相关服务有关的协议和规则（包括但不限于《隐私政策》）
                的约束。</p>

            <p>1.5&nbsp;&nbsp;我方有权依本软件及相关服务或运营的需要单方决定，安排或指定关联方、控制公司、继承公司或公司认
                可的第三方公司继续运营软件。并且，就本协议项下涉及的某些服务，可能会由公司的关联方、控制公司、
                继承公司或公司认可的第三方公司向您提供。您知晓并同意接受相关服务内容，即视为接受相关权利义务关
                系亦受本协议约束。</p>

            <p>1.6&nbsp;&nbsp;如对本协议内容有任何疑问、意见或建议，请您及时通过我方提供的官方联系方式同我方取得联系。</p>

            <h1>2.&nbsp;本软件及相关服务</h1>

            <p>2.1&nbsp;&nbsp;您可以通过我方官网或其他我方官方授权的渠道获取本软件并接受相关服务。若您并非通过我方官网或
                其他我方官方授权的渠道获取软件的，我方无法保证非官方版本的软件能够正常使用，您因此遭受的损失
                与我方无关。</p>

            <p>2.2&nbsp;&nbsp;我方可能为不同的终端设备开发不同的应用程序软件版本，您应当根据实际设备状况获取、下载、安装合
                适的版本。</p>

            <p>2.3&nbsp;&nbsp;您可根据需要自行使用本软件及相关服务或更新版本，如您不再需要使用本软件及相关服务，您也可自行
                卸载相应的应用程序软件。</p>

            <p>2.4&nbsp;&nbsp;为更好的提升用户体验及服务，我方将不定期提供本软件及相关服务的更新或改变（包括但不限于软件修
                改、升级、功能强化、开发新服务、软件替换等），您可根据需要自行选择是否更新相应的版本。为保证本软
                件及相关服务安全、提升用户服务，本软件及相关服务部分或全部更新后，我方将在可行情况下以适当方式
                （包括但不限于系统提示、公告、站内信等）提示您；您在此知悉并认可本软件的替换版本或修改版本或升级
                版本发布后，我方不保证旧版本（指本软件的替换版本或修改版本或升级版本发布之前的版本）继续可用。我
                方保留因业务发展需要，单方面对本软件的部分功能效果进行改变或进行限制的权利，您应承担与此相关的风险。</p>

            <p>2.5&nbsp;&nbsp;除非得到我方明示事先书面授权，您不得以任何形式对本软件及相关服务进行包括但不限于改编、复制、传播、
                镜像、交易以及将本软件作为为其他人提供服务的工具等未经授权的访问或使用。</p>

            <p>2.6&nbsp;&nbsp;您理解，您使用本软件及相关服务需自行准备与本软件及相关服务有关的终端设备（如电脑、手机等装置），
                一旦您在您终端设备中打开软件或访问相关网站，即视为您使用本软件及相关服务。为充分实现的全部功能，
                您可能需要将您的终端设备联网，您应自行承担所需要的费用（如流量费、上网费等）。</p>

            <p>
                2.7&nbsp;&nbsp;我方许可您一项个人的、可撤销的、不可转让的、非独占地和非商业的合法使用本软件及相关服务的权利，
                您不享有本软件的所有权。请您尤其注意，我方基于本协议对您的授权仅为授权您个人以非商业的目的对于本软
                件及相关服务进行使用，任何超出个人使用目的的使用行为都必须另行获得我方具体的、单独的书面授权，协议
                未明示授权的其他一切权利仍由我方保留，您在行使该等权利前须另行获得我方的书面许可，同时我方如未行使
                前述任何权利，并不构成对该权利的放弃。授权的有效性依赖于如下条件：<br>
                （1）本软件的安装和使用均未违反本协议及本软件上的各项规则。<br>
                （2） 您取得了必要的授权和资格以安装和使用本软件。<br>
                （3） 本协议被无保留和修改地全部接受，且没有被违反。<br>
                （4） 您未通过任何方式侵犯我方的知识产权或其他合法权利。
            </p>

            <p>2.8&nbsp;&nbsp;您不得将本软件及相关服务用于任何非法或侵权活动，包括但不限于利用软件及相关服务侵犯他人隐私
                权利、知识产权，将其用于展示、传播包含色情、种族主义、低级趣味、淫秽、诽谤中伤、污辱性质的资
                料，以及传播任何针对宗教、民族传统、人种、性别、年龄的各种仇恨、歧视、侵权和偏见的内容。</p>

            <p>2.9&nbsp;&nbsp;如果您发现在本软件及相关服务中存在任何侵犯您权利的内容，您可以通过我方提供的联系方式与我方取
                得联系，并提供您有相关权利的证据，我方将会依据相关法律规定及时处理您的反馈。</p>

            <h1>3.&nbsp;关于“帐号”</h1>

            <p>3.1&nbsp;&nbsp;本软件及相关服务为您提供了注册通道。您设置的帐号、密码是用以登录并以注册用户身份使用本软件及
                相关服务的凭证。</p>

            <p>3.2&nbsp;&nbsp;帐号注销在需要终止使用帐号服务时，符合以下条件的，您可以申请注销您的帐号：<br>
                （1）您仅能申请注销您本人的帐号，并依照我方的流程进行注销；<br>
                （2）您仍应对您在注销帐号前、使用服务期间的行为承担相应责任；<br>
                （3）注销成功后，帐号记录、功能等将无法恢复或提供。<br>
                （4）对于您的账号中尚存的全部权益（包括会员权益、余额等），您选择主动放弃。<br>
                如您需要注销您的帐号，你可以通过本软件及相关页面设置的指引执行账号的注销，或通过官方渠道与我
                司取得联系要求注销您的账号，我方会在收到您的请求后十五个工作日内，完成注销或与您协商以确认账
                号注销事宜。</p>

            <p>3.3&nbsp;&nbsp;您理解并承诺，您所设置的帐号不得违反国家法律、法规及的相关规则，您的帐号名称、头像等注册信
                息及其他个人信息中不得出现违法和不良信息，未经他人许可不得用他人名义（包括但不限于冒用他人姓
                名、名称、头像等或采取其他足以让人引起混淆的方式）开设帐号，不得恶意注册帐号（包括但不限于频
                繁注册、批量注册帐号等行为）。您在帐号注册及使用过程中需遵守相关法律法规，不得实施任何侵害国
                家利益、损害其他公民合法权益，有害社会道德风尚的行为。我方有权对您提交的注册信息进行审核，但
                我方的审核行为不为我方设立任何义务。</p>

            <p>3.4&nbsp;&nbsp;您注册的帐号仅限于您本人使用，未经我方书面同意，禁止以任何形式赠与、借用、出租、转让、售卖
                或以其他方式许可他人使用该帐号。如果我方发现或者有合理理由认为使用者并非帐号初始注册人，为保
                障帐号安全，我方有权立即暂停或终止向该注册帐号提供服务，并有权永久禁用该帐号。</p>

            <p>3.5&nbsp;&nbsp;您有责任维护个人帐号、密码的安全性与保密性，并对您以注册帐号名义所从事的活动承担全部法律责
                任，包括但不限于您在本软件及相关服务上进行的任何数据修改、言论发表、款项支付等操作行为可能引
                起的一切法律责任。您应高度重视对帐号与密码的保密，在任何情况下不向他人透露帐号及密码。若发现
                他人未经许可使用您的帐号或发生其他任何安全漏洞问题时，您应当立即通知我方。</p>

            <p>3.6&nbsp;&nbsp;如您遗忘了账号信息、密码或因为其他情况导致无法通过账号登录，可以通过软件及相关页面的引导或
                联系我方官方请求找回账号信息。您理解并认可，账号找回机制仅识别申请找回人提供的信息与后台信息
                是否一致，而无法保证申诉人是否系帐号真正有权使用者。我方特别提醒您应妥善保管您的帐号和密码。
                当您使用完毕后，应退出。因您保管不当等自身原因或其他不可抗因素导致遭受盗号或密码丢失，您应自
                行承担相应责任。</p>

            <p>3.7&nbsp;&nbsp;在注册、使用和管理帐号时，您应保证注册帐号时填写的身份信息的真实性，请您在注册、管理帐号时
                使用真实、准确、合法、有效的相关身份证明材料及必要信息。依照国家法律法规的规定，为使用本软件及
                相关服务的部分功能（比如发帖、评论等），您需要填写真实的身份信息，请您按照相关法律规定完成实名
                认证，并注意及时更新上述相关信息。[针对软件中的跟帖、评论等内容发布功能，要求实名认证，如果软件
                以及官网等页面中均不涉及该等功能，这部分内容可以选择进行删除。]若您提交的材料或提供的信息不准确、
                不真实、不规范、不合法或者我方有理由怀疑为错误、不实或不合法的资料，则我方有权拒绝为您提供相关服
                务，您可能无法使用本软件及相关服务或在使用过程中部分功能受到限制。</p>

            <p>3.8&nbsp;&nbsp;除自行注册帐号外，您也可选择通过授权使用您合法拥有的包括但不限于我方和/或其关联方的其他软件
                或平台用户帐号登录使用本软件及相关服务。当您以前述已有帐号登录使用的，应保证相应帐号已进行实名
                注册登记，并同样适用本协议中的相关条款。</p>

            <p>3.9&nbsp;&nbsp;您理解并同意，除您登录、使用本软件及相关服务外，您可能还可以用帐号登录使用我方及关联方或其
                他合作方提供的其他软件、服务。您以帐号登录并使用前述服务的，同样应受其他软件、服务实际提供方
                的用户协议及其他协议条款约束。您帐号的头像、昵称等公开信息可能会一并同步。</p>

            <p>3.10&nbsp;&nbsp;当您完成的帐号注册、登录并进行合理和必要的身份验证后，您可以向我方要求查询、修正自己提交
                的个人身份信息。您理解并同意，出于安全性和身份识别（如帐号信息或密码找回服务等）的考虑，您可
                能无法修改注册时提供的初始注册信息及其他验证信息。您也可以申请注销帐号，我方会在完成个人身份
                、安全状态、设备信息、侵权投诉等方面的合理和必要的验证后协助您注销帐号，并依照您的要求删除有
                关您帐号的一切信息，法律法规另有规定的除外。</p>

            <h1>4.&nbsp;用户个人信息保护</h1>

            <p>我方与您一同致力于您个人信息（即能够独立或与其他信息结合后识别您身份的信息）的保护。保护用户个
                人信息是我方的基本原则之一，在使用本软件及相关服务的过程中，您可能需要提供您的个人信息（包括
                但不限于您的姓名、电话号码、位置信息、设备信息等），以便我方向您提供更好的服务和相应的技术支
                持。我方将依法保护您浏览、修正、删除相关个人信息以及撤回授权的权利，并将运用加密技术、匿名化
                处理等其他与本软件及相关服务相匹配的技术措施及其他安全措施保护您的个人信息。更多关于您个人信
                息保护的内容，请参看《隐私政策》，本协议与《隐私政策》有不符的，以《隐私政策》内容为准。</p>

            <h1>5.&nbsp;用户行为规范</h1>

            <p>5.1&nbsp;&nbsp;用户行为要求您应对您使用本软件及相关服务的行为负责，除非法律允许或者经我方事先书面许可，您
                使用本软件及相关服务不得具有下列行为：</p>

            <p>5.1.1&nbsp;&nbsp;使用未经我方授权或许可的任何插件、外挂、系统或第三方工具对本软件及相关服务的正常运行进行干
                扰、破坏、修改或施加其他影响。</p>

            <p>5.1.2&nbsp;&nbsp;利用或针对本软件及相关服务进行任何危害计算机网络安全的行为，包括但不限于：<br>
                （1）非法侵入网络、干扰网络正常功能、窃取网络数据等危害网络安全的活动；<br>
                （2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；<br>
                （3）明知他人从事危害网络安全的活动的，为其提供技术支持等帮助；<br>
                （4）使用未经许可的数据或进入未经许可的服务器/帐号；<br>
                （5）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；<br>
                （6）未经许可，企图探查、扫描、测试系统或网络的弱点或其它实施破坏网络安全的行为；<br>
                （7）企图干涉、破坏系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；<br>
                （8）对本软件及相关服务进行反向工程、反向汇编、编译或者以其他方式尝试发现本软件及相关服务的源代码；<br>
                （9）恶意注册帐号，包括但不限于频繁、批量注册帐号；<br>
                （10）违反法律法规、本协议、我方的相关规则及侵犯他人合法权益的其他行为。
            </p>

            <p>5.1.3&nbsp;&nbsp;如果我方有理由认为您的行为违反或可能违反上述约定的，我方可独立进行判断并处理，且在任何时
                候有权在不事先通知的情况下终止向您提供服务，并依法追究相关责任。请注意，这不代表我方保证能够及
                时处理你的所有违约行为，也不为我方设立任何义务。</p>

            <p>5.2&nbsp;&nbsp;信息内容展示及规范</p>

            <p>5.2.1&nbsp;&nbsp;您按规定完成实名认证后，可以发布信息、互动交流、评论等。</p>

            <p>5.2.2&nbsp;&nbsp;您制作、评论、发布、传播的信息应自觉遵守法律法规，保证该等信息不侵害国家、
                社会或其他任何第三人的合法权益，并保证其真实性，否则我方有权立即采取相应处理措施。您同意并承
                诺不制作、复制、发布、传播下列信息：<br>
                （1）反对宪法确定的基本原则的；<br>
                （2）危害国家安全，泄露国家秘密的；<br>
                （3）颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家统一的；<br>
                （4）损害国家荣誉和利益的；<br>
                （5）宣扬恐怖主义、极端主义的；<br>
                （6）宣扬民族仇恨、民族歧视，破坏民族团结的；<br>
                （7）煽动地域歧视、地域仇恨的；<br>
                （8）破坏国家宗教政策，宣扬邪教和封建迷信的；<br>
                （9）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的；<br>
                （10）散布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>
                （11）危害网络安全、利用网络从事危害国家安全、荣誉和利益的；<br>
                （12）侮辱或者诽谤他人，侵害他人合法权益的；<br>
                （13）对他人进行暴力恐吓、威胁，实施人肉搜索的；<br>
                （14）涉及他人隐私、个人信息或资料的；<br>
                （15）散布污言秽语，损害社会公序良俗的；<br>
                （16）侵犯他人隐私权、名誉权、肖像权、知识产权等合法权益内容的；<br>
                （17）散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息；<br>
                （18）侵害未成年人合法权益或者损害未成年人身心健康的；<br>
                （19）包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的，包括但不限于以下情形：<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;i. 任何暴力和/或自残行为内容；<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;ii. 任何威胁生命健康、危及自身或他人人身及/或财产权利的内容；<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;iii.怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容；<br>
                （20）其他含有违反法律法规、政策及公序良俗、干扰正常运营或侵犯其他用户或第三方合法权益内容的信息。</p>

            <p>5.3&nbsp;&nbsp;您可以通过软件及相关页面内的反馈渠道向我方投诉、举报各类违法违规行为、违法传播活动、违法有
                害信息等内容，我方将及时受理和处理您的投诉举报。</p>

            <h1>6.&nbsp;信息内容使用规范</h1>

            <p>未经我方书面许可，任何用户、第三方均不得自行或授权、允许、协助他人对本软件及相关服务中信息内容进行如下行为：<br>
                （1）复制、读取、采用本软件及相关服务的信息内容，用于商业用途；<br>
                （2）擅自编辑、整理、编排本软件及相关服务的信息内容后在本软件及相关服务的页面以外的渠道进行展示；<br>
                （3）自行或协助第三人对本软件及相关服务的信息内容产生流量、阅读量引导、转移、劫持等不利影响；<br>
                （4）其他非法获取或使用本软件及相关服务的信息内容的行为。</p>

            <h1>7.&nbsp;违约处理</h1>

            <p>7.1&nbsp;&nbsp;针对您违反本协议或其他服务条款的行为，我方有权独立判断并视情况采取预先警示、删除内容、短期
                禁止发布内容、限制帐号部分或者全部功能直至终止提供服务、永久关闭帐号等措施，对于因此而造成您
                无法正常使用帐号及相关服务、无法正常获取您帐号内资产或其他权益等后果，我方不承担任何责任。我
                方有权公告处理结果，且有权根据实际情况决定是否恢复相关帐号的使用。对涉嫌违反法律法规、涉嫌违
                法犯罪的行为，我方将保存有关记录，并有权依法向有关主管部门报告、配合有关主管部门调查、向公安
                机关报案等。对已删除内容我方有权不予恢复。</p>

            <p>7.2&nbsp;&nbsp;因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行处理并承担可能因此
                产生的全部法律责任。因您的违法或违约等行为导致我方及其关联公司、控制公司、继承公司向任何第三
                方赔偿或遭受国家机关处罚的，您还应足额赔偿我方及其关联公司、控制公司、继承公司因此遭受的全部
                损失。</p>

            <p>7.3&nbsp;&nbsp;我方尊重并保护用户及他人的知识产权、名誉权、姓名权、隐私权等合法权益。您保证，在使用本软件
                及相关服务时上传的文字、图片、视频、音频、链接等不侵犯任何第三方的知识产权、名誉权、姓名权、
                隐私权等权利及合法权益。否则，我方有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。
                针对第三方提出的全部权利主张，您应自行处理并承担可能因此产生的全部法律责任；如因您的侵权行为
                导致我方及其关联公司、控制公司、继承公司遭受损失的（包括但不限于经济、商誉等损失），您还应足
                额赔偿我方及其关联方、控制公司、继承公司遭受的全部损失。</p>

            <h1>8.&nbsp;服务的变更、中断和终止</h1>

            <p>8.1&nbsp;&nbsp;您理解并同意，我方提供的本软件及相关服务是按照现有技术和条件所能达到的现状提供的。我方会尽
                最大努力向您提供服务，确保服务的连贯性和安全性。您理解，我方不能随时或始终预见和防范法律、技
                术以及其他风险，包括但不限于不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服
                务中断、不能正常使用本软件及相关服务以及其他的损失和风险。</p>

            <p>8.2&nbsp;&nbsp;您理解并同意，我方为了整体服务运营、平台运营安全的需要，有权视具体情况决定服务/功能的设置及
                其范围修改、中断、中止或终止本软件及相关服务。</p>

            <h1>9.&nbsp;广告</h1>

            <p>9.1&nbsp;&nbsp;您理解并同意，我方可能会在软件及相关服务页面向您展示、推送具有相关性的信息、广告发布或品牌
                推广信息等，包括向您展示第三方的商业广告。对于第三方商业广告的真实性，我司无法提供保证，请你
                自行确认，并审慎理解该等广告信息。</p>

            <p>9.2&nbsp;&nbsp;我司还有可能通过电子邮件、手机短信等方式向您发送商业广告，您可以选择拒绝接受该等广告，如果
                您选择拒绝，我方将不再通过对应的渠道向您提供该等商业广告。</p>

            <h1>10.&nbsp;知识产权</h1>

            <p>10.1&nbsp;&nbsp;我方在本软件及相关服务中提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像
                、音频、视频、图表、版面设计、电子文档等）的知识产权属于我方及其实际权利人所有。我方提供及相
                关服务时所依托的软件的著作权、专利权及其他知识产权均归我方及其实际权利人所有。未经我方极其实
                际权利人许可，任何人不得擅自使用（包括但不限于通过任何机器人、“蜘蛛”等程序或设备监视、复制、
                传播、展示、镜像、上载、下载）本软件及相关服务中的内容。</p>

            <p>10.2&nbsp;&nbsp;您不得删除本软件上的任何权利标识。</p>

            <p>10.3&nbsp;&nbsp;您不得在未经过授权的情况下对于本软件中包含的任何权利标识进行任何明示或暗示地使用。</p>

            <p>10.4&nbsp;&nbsp;您理解并承诺，您在使用本软件及相关服务时发布上传的内容（包括但不限于文字、图片、音频等各
                种形式的内容及其中包含的音乐、声音、台词、视觉设计等所有组成部分）均由您原创或已获合法授权
                （且含转授权）。您通过上传、发布所产生内容的知识产权归属您或原始著作权人所有。</p>

            <p>10.5&nbsp;&nbsp;您知悉、理解并同意，您通过本软件及相关服务上传、发布的内容（包括但不限文字，图像，音频，
                视频内容等各种形式的内容及其中包括的音乐、声音、台词、视觉设计、对话等所有组成部分），您授
                予我方及其关联公司、控制公司、继承公司一项全球范围内、免费、非独家、可再许可（通过多层次）
                的权利（包括但不限于复制权、翻译权、汇编权、信息网络传播权、改编权及制作衍生品、表演和展示
                的权利等），上述权利的使用范围包括但不限于在当前或其他网站、应用程序、产品或终端设备等使用。
                您在此确认并同意，我方有权自行或许可第三方在与上述内容、本软件及相关服务、我方和/或我方品牌
                有关的任何宣传、推广、广告、营销和/或研究中使用和以其他方式开发内容（全部或部分）。为避免疑
                义，您理解并同意，上述授予的权利包括使用、复制和展示您拥有或被许可使用并植入内容中的个人形象
                、肖像、姓名、商标、服务标志、品牌、名称、标识和我方标记（如有）以及任何其他品牌、营销或推广
                资产、物料、素材等的权利和许可。</p>

            <h1>11.&nbsp;免责声明</h1>

            <p>11.1&nbsp;&nbsp;您理解并同意，本软件及相关服务可能会受多种因素的影响或干扰，我方不保证(包括但不限于)：</p>

            <p>11.1.1&nbsp;&nbsp;本软件及相关服务完全适合用户的使用要求；</p>

            <p>11.1.2&nbsp;&nbsp;本软件及相关服务不受干扰，及时、安全、可靠或不出现错误；用户经由我方取得的任何软件、
                服务或其他材料符合用户的期望；</p>

            <p>11.1.3&nbsp;&nbsp;本软件及相关服务中任何错误都将能得到更正。</p>

            <p>11.2&nbsp;&nbsp;针对您在使用我方软件及相关服务过程中所接触到的信息，请您谨慎对待并自行判断其真实性，对于
                您基于我方软件及相关服务上的信息所执行的行为给您造成的损失，我方不承担任何直接、间接、附带、
                特别、衍生性或惩罚性的赔偿责任。</p>

            <p>11.3&nbsp;&nbsp;您理解并同意，在使用本软件及相关服务过程中，可能遇到不可抗力等因素（不可抗力是指不能预
                见、不能克服并不能避免的客观事件），包括但不限于政府行为、自然灾害（如洪水、地震、台风等）
                、网络原因、战争、罢工、骚乱等。出现不可抗力情况时，我方将努力在第一时间及时修复，但因不可
                抗力造成的暂停、中止、终止服务或造成的任何损失，我方在法律法规允许范围内免于承担责任。</p>

            <p>11.4&nbsp;&nbsp;我方依据本协议约定获得处理违法违规内容的权利，该权利不构成我方的义务或承诺，我方不能保
                证及时发现违法行为或进行相应处理。</p>

            <p>11.5&nbsp;&nbsp;您理解并同意：我方仅以软件及相关服务当前的实际使用效果向你提供保证，关于本软件及相关服务
                ，我方不提供任何种类的明示或暗示担保或条件，包括但不限于对于本软件及相关服务的有效性、使用效
                果等进行保证。您对本软件及相关服务的使用行为应自行承担相应风险。</p>

            <p>11.6&nbsp;&nbsp;在任何情况下，我方均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因
                您使用本软件及相关服务而遭受的利润损失，承担责任。除法律法规另有明确规定外，我方对您承担的全
                部责任，无论因何原因或何种行为方式，始终不超过您因使用本软件及相关服务期间而支付给我方的费用
                （如有）。</p>

            <h1>12.&nbsp;关于付费购买内容</h1>

            <p>12.1&nbsp;&nbsp;本软件及相关服务部分内容您需要通过付费以获取，你可以自行选择是否进行付费。请您购买前仔细
                阅读具体付费内容的功能效果、服务内容、使用规则等，对于具体的付费内容有疑问的，请您在购买前及
                时咨询我方进行确认。针对部分付费功能存在单独的协议的，您应保证您在购买前已经仔细阅读、理解并
                同意对应协议的全部内容。</p>

            <p>12.2&nbsp;&nbsp;如某项具体的服务、权益未标明使用期限、或未明使用期限为“永久”、“无限期”或“无限制”的，则这
                些服务的使用期限为自您开始使用该服务至该服务在软件停止提供之日为止。</p>

            <h1>13.&nbsp;未成年人使用条款</h1>

            <p>13.1&nbsp;&nbsp;若您是未成年人，您应在您的监护人监护、指导下并获得监护人同意的情况下，认真阅读并同意本协议
                后，方可使用本软件及相关服务。</p>

            <p>13.2&nbsp;&nbsp;我方重视对未成年人个人信息的保护，未成年用户在填写个人信息时，请加强个人保护意识并谨慎对待
                ，并应在取得监护人的同意以及在监护人指导下正确使用本软件及相关服务。</p>

            <p>13.3&nbsp;&nbsp;未成年人用户及其监护人理解并确认，如您违反法律法规、本协议内容，则您及您的监护人应依照法律
                规定承担因此而可能导致的全部法律责任。</p>

            <h1>14.&nbsp;其他</h1>

            <p>14.1&nbsp;&nbsp;本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国法律。倘若本协议之任何规定因
                与中华人民共和国法律抵触而无效，则这些条款应在不违反法律的前提下按照尽可能接近本协议原条文目的之
                原则进行重新解释和适用，且本协议其它规定仍应具有完整的效力及效果。</p>

            <p>14.2&nbsp;&nbsp;本协议的签署地点为中华人民共和国江苏省苏州市工业园区 ，若您与我方发生任何争议，双方应尽量友好
                协商解决，协商不成，您同意应将争议提交至苏州市朝旭科技有限公司所在地有管辖权的法院管辖。</p>

            <p>14.3&nbsp;&nbsp;如果您对于本协议及其执行有任何疑问，请您及时与我方取得联系并进行确认</p>

            <p>联系方式：苏州工业园区娄门路237号H座101室</p>
            <p style="margin: 0">客服电话：15565734199</p>
            <p style="margin: 0">服务邮箱：guoshixiongkefu@163.com</p>

            <p style="text-align: right">苏州市朝旭科技有限公司</p>

        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            
        }
    },
    mounted(){

    },
    created(){
        
    },
    methods:{
        
    },
    components:{
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/base.scss';
.agreement-page {
    padding-bottom: 10px;
    .main-section{
        padding:20px 20px 0;
    }
    .main-section > h1 {
        color: #262626;
        font-size: 16px;
        font-weight: bold;
        margin-top: 20px;
    }
    .main-section > p {
        font-size: 14px;
        color: #262626;
        line-height: 21px;
        margin-top: 16px;
    }
    
}
</style>



// WEBPACK FOOTER //
// src/static/guoshixiong/Agreement.vue